export default /* @ngInject */ ($filter, $sce) => (input) => {
    let formatted;

    if (input === 0) {
        formatted = $sce.trustAsHtml('&#8212;');
    } else {
        const abs = Math.abs(input);
        const float = parseFloat(abs);
        const noDecimal = float.toFixed(0);
        const number = $.number(noDecimal, 0, '.', ' ');

        if (input < 0) {
            formatted = $sce.trustAsHtml(`<span>(${number})</span>`);
        } else if (number == 0) {
            formatted = $sce.trustAsHtml('&#8212;');
        } else {
            formatted = $sce.trustAsHtml(number);
        }
    }

    return formatted;
};
